/*!
 * Copyright © 2024. Verizon Connect Ireland Limited. All rights reserved.
 */

export interface IVideoDeviceInfoState {
  earliestRecordingUTC: Date;
  online: boolean;
  isVodRequestEnabled: boolean;
}

export const initialDeviceInfoState: IVideoDeviceInfoState = {
  earliestRecordingUTC: new Date(),
  online: false,
  isVodRequestEnabled: false
};
